import { useMemo } from 'react';

import { useConversationActionsStoreActions } from '@atlassian/rovo-conversation-actions/conversation-actions-store';

import { useAISmartButtonActions } from '../../ai-smart-button-store';

/**
 * Hook for managing presentation view of ai actions.
 */
export const useSourceAnalyticActions = () => {
	const { setButtonClickedTimestamp } = useAISmartButtonActions();
	const conversationActionsStoreActions = useConversationActionsStoreActions();
	return useMemo(
		() => ({
			/**
			 * Set the button clicked timestamp for the source.
			 */
			setButtonClickedTimestamp: (buttonClickedTimestamp: number) => {
				setButtonClickedTimestamp(buttonClickedTimestamp);
				conversationActionsStoreActions.setButtonClickedTimestamp(buttonClickedTimestamp);
			},
		}),
		[setButtonClickedTimestamp, conversationActionsStoreActions],
	);
};

export type SourceAnalyticActions = ReturnType<typeof useSourceAnalyticActions>;
